module.exports = __webpack_public_path__ + "assets/img/locationIcon.34bec84f.svg";